// extracted by mini-css-extract-plugin
export default {"root":"Image__root___Uz3Zl","withFallback":"Image__withFallback___Giu8c","placeholder":"Image__placeholder___vauHe"};